import { render, staticRenderFns } from "./concept.vue?vue&type=template&id=44015168&scoped=true"
import script from "./concept.vue?vue&type=script&lang=js"
export * from "./concept.vue?vue&type=script&lang=js"
import style0 from "./concept.vue?vue&type=style&index=0&id=44015168&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44015168",
  null
  
)

export default component.exports